import { AutocompleteFieldItem } from '@domains/documents-review/interfaces/interfaces';
import { SuggestionFeedbackItem } from '@domains/documents-review/store/api-slices/suggestions-feedback.endpoints';
import { mapFeedbackType } from './feedbackType';

interface BuildSuggestionsFeedbackParams {
  items: AutocompleteFieldItem[];
  country: string;
  nid: string;
  agentEmail: string;
}

export const buildSuggestionsFeedback = ({
  items,
  country,
  nid,
  agentEmail,
}: BuildSuggestionsFeedbackParams): SuggestionFeedbackItem[] => {
  return items
    .filter(it => it.reviewed || (it.finalValue && it.finalValue !== ''))
    .map(it => ({
      country,
      nid,
      field: it.field,
      fieldId: it.fieldId as number,
      suggestionId: it.selectedSuggestionId ?? it.defaultSuggestionId ?? null,
      finalValue: it.finalValue ?? '',
      selectedModel: it.defaultModel ?? '',
      finalConfidence: it.finalConfidence ?? 0,
      feedbackType: mapFeedbackType(it),
      agentEmail,
      agentComment: it.agentComment,
    }));
};
